export const FAVOURITES_FILTER = '_favourites';
export function emptySearchRequest() {
    return { query: null, filters: [] };
}
/**
 * Determines the search request to start with: the enforced one, else the
 * stored one (if it has a query or filters), else the grid default.
 */
export function resolveInitialSearchRequest(input) {
    if (input.enforce && input.propSearchRequest) {
        return { searchRequest: input.propSearchRequest, shouldEmit: false };
    }
    const stored = input.stored;
    if (stored && (stored.query || (stored.filters && stored.filters.length > 0))) {
        return { searchRequest: stored, shouldEmit: input.propSearchRequest !== stored };
    }
    return { searchRequest: input.gridDefault || emptySearchRequest(), shouldEmit: true };
}
/**
 * The search filters offered to the user: the grid's filters, preceded by the
 * special favourites filter if favourites are enabled. Never mutates
 * `gridFilters`; returns it as is when favourites are disabled.
 */
export function createFilters(gridFilters, favouritesLabel) {
    if (favouritesLabel === null) {
        return gridFilters;
    }
    return [
        {
            name: FAVOURITES_FILTER,
            label: favouritesLabel,
            category: 'special',
            type: 'bool',
        },
        ...gridFilters,
    ];
}
export function hasFavouritesFilter(searchRequest) {
    return (searchRequest.filters || []).some(f => f.attribute === FAVOURITES_FILTER);
}
/**
 * Replaces the special favourites filter with an ID filter for the given
 * favourite item IDs.
 */
export function prepareSearchRequest(searchRequest, favouriteIds) {
    const filters = (searchRequest.filters || []).map(filter => {
        if (filter.attribute === FAVOURITES_FILTER) {
            return {
                attribute: 'id',
                operator: (filter.values[0] ? 'eq' : 'neq'),
                values: favouriteIds,
            };
        }
        return filter;
    });
    return {
        query: searchRequest.query,
        filters: filters,
    };
}
